import React, { PropTypes } from "react"
import Link from "react-router/lib/Link"
import Table from "react-bootstrap/lib/Table"

const List = ({ data }) => (
  <Table condensed hover>
    <thead>
      <tr>
        <th>#</th>
        <th>Control #</th>
        <th>Section</th>
        <th>Subject</th>
        <th># of Students</th>
        <th>Date Submitted</th>
        <th>Date Approved</th>
        <th>Print</th>
      </tr>
    </thead>
    <tbody>
      {data.map((item, k) => {
        return (
          <tr key={k}>
            <td>{k + 1}.</td>
            <td>{item.get("id")}</td>
            <td>{item.getIn(["offering_group", "section"])}</td>
            <td>
              <code>{item.get("subject_code")}</code>
            </td>
            <td>{item.get("student_count")}</td>
            <td>{item.get("created_date")}</td>
            <td>{item.get("approved_date")}</td>
            <td>
              <Link
                to={`/print/grades-submitted/${item.get("id")}`}
                type="button"
                target="_blank"
                className="btn btn-sm btn-warning"
              >
                Print
              </Link>
            </td>
          </tr>
        )
      })}
    </tbody>
  </Table>
)

List.propTypes = {
  data: PropTypes.object,
}

export default List



// WEBPACK FOOTER //
// ./src/containers/GradesSubmitted/list.js